export function getRequestUri() {
    return window.location.pathname + window.location.search + window.location.hash
}

export function getCurrentPageUrl(): string {
    const location: Location = window.location
    return `https://${location.hostname}${location.port ? `:${location.port}` : ""}${location.pathname}`
}
